module.exports = __webpack_public_path__ + "static/img/science4.6d67069c.png";